import { AfterViewInit, ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ENVIRONMENT, IEnvironmentState } from '@spout/global-web/models';
import { BehaviorSubject, Subject } from 'rxjs';

class HOMEPAGE_DOWNLOADS {
  windows: string = "";
  mac: string = "";
  macm1: string = "";
}
const devDownloads: HOMEPAGE_DOWNLOADS =
{
  windows: "https://firebasestorage.googleapis.com/v0/b/spout-dev-d0c97.appspot.com/o/installers%2FSpout%20Studio%20Dev-x64.msix?alt=media&token=c2e7e9e1-1eca-45fe-8652-1815b8c0ba54",
  mac: "https://firebasestorage.googleapis.com/v0/b/spout-dev-d0c97.appspot.com/o/installers%2Fspout-installer-intel-dev.dmg?alt=media&token=399e5a1c-c194-47d7-b21a-b6534f841f7f",
  macm1: "https://firebasestorage.googleapis.com/v0/b/spout-dev-d0c97.appspot.com/o/installers%2Fspout-installer-m1-dev.dmg?alt=media&token=000f15a7-482a-4171-96eb-48379c70ee1b"
};

const prodDownloads: HOMEPAGE_DOWNLOADS ={
  windows: "https://firebasestorage.googleapis.com/v0/b/spout-prod.appspot.com/o/installers%2FSpout%20Studio-x64.msix?alt=media&token=89e7d8af-4539-4f5a-bf16-06fcca044404",
  mac: "https://firebasestorage.googleapis.com/v0/b/spout-prod.appspot.com/o/installers%2Fspout-installer-intel.dmg?alt=media&token=3a93a88d-72fb-4bc9-9d75-cacbbd79ac0b",
  macm1: "https://firebasestorage.googleapis.com/v0/b/spout-prod.appspot.com/o/installers%2Fspout-installer-m1.dmg?alt=media&token=c79946de-607d-4260-9a55-21178f4d08da"
} as HOMEPAGE_DOWNLOADS
;



@Component({
  selector: 'spt-new-homepage',
  templateUrl: './new-homepage.component.html',
  styleUrls: ['./new-homepage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewHomepageComponent implements AfterViewInit {
 
  public isMobile$: BehaviorSubject<boolean>;
  public downloads$: Subject<HOMEPAGE_DOWNLOADS>;

  
  constructor(private router: Router,
    @Inject(ENVIRONMENT) public environment: IEnvironmentState) {
    this.isMobile$ = new BehaviorSubject<boolean>(false);
    this.downloads$ = new BehaviorSubject<HOMEPAGE_DOWNLOADS>(environment?.production == false?devDownloads:prodDownloads);
    
  }

  ngAfterViewInit(): void {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      this.isMobile$.next(true);
    }
  }
  gotoSubscriptions() {
    this.router.navigate(['subscribe']);
  }
  clickTier(tier: number) {
    this.router.navigate(['checkout'], {
      queryParams: {
        s: tier
      }
    });
  }

}
